module.exports = __webpack_public_path__ + "static/media/vincent_cheung.c40fdb44.png";